<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
/>

<main class="tw-py-8 xl:tw-py-20 !tw-text-center md:!tw-text-left">
    <section class="tw-flex tw-flex-col tw-items-start tw-px-[30px] xl:tw-px-0">
        <div class="container">
            <div
                class="tw-bg-[#95D1F3] tw-py-1 tw-px-3 tw-rounded-md tw-w-fit tw-font-bold tw-text-sm sm:tw-text-base lg:tw-text-[1rem]"
            >
                {{ "CAMPAIGN_PAGE.CAMPAIGN_PERIOD" | translate }}
                {{ campaignStartDate }} - {{ campaignEndDate }}
            </div>
            <div
                class="tw-text-[#8D8D8D] tw-text-sm sm:tw-text-base lg:tw-text-lg xl:tw-text-xl tw-mt-3 sm:tw-mt-4 lg:tw-mt-6 content-details tw-break-words tw-whitespace-pre-line tw-max-h-[200px] sm:tw-max-h-[250px] lg:tw-max-h-[300px] tw-overflow-y-auto tw-w-full"
                [innerHTML]="campaignData?.campaigndetails?.campaignDescription"
            ></div>
            <div
                class="tw-mt-2 sm:tw-mt-3 sm:tw-text-[22px] xl:tw-text-[45px] !tw-leading-[1.5] tw-font-bold tw-break-words tw-w-full"
                [title]="campaignData?.campaigndetails?.campaignName"
            >
                {{ campaignData?.campaigndetails?.campaignName }}
            </div>
        </div>
    </section>

    <section class="tw-mt-10 md:tw-mt-12 tw-px-[30px] xl:tw-px-0">
        <div class="container">
            <img
                style="height: auto; max-height: 800px"
                [attr.ga-event-id]="
                    campaignData?.campaigndetails?.campaignName +
                    '_main_banner_campaign_click'
                "
                ga-event-category="Campaign Page Banner"
                ga-event-label="Campaign Main Banner Click"
                ga-track="track"
                src="{{ campaignData?.campaigndetails?.campaignDetImageUrl }}"
                class="tw-rounded-[20px] md:tw-rounded-[40px] tw-cursor-pointer tw-w-full"
                (click)="
                    openProductPage(
                        campaignData?.campaigndetails?.campaignDetUrl,
                        campaignData?.campaignpartner,
                        campaignData?.campaignsource,
                        campaignData?.ctaType
                    )
                "
                alt="Campaign detail"
            />
        </div>
    </section>
    <section class="tw-mt-12 lg:tw-mt-20 tw-flex tw-flex-col">
        <div
            *ngIf="
                campaignData?.campaigndetails?.title1 ||
                campaignData?.campaigndetails?.title1Desc
            "
            class="tw-flex tw-flex-col tw-gap-y-5 tw-px-[30px] xl:tw-px-0 tw-py-5"
        >
            <div class="container">
                <div class="tw-flex-1 tw-text-2xl tw-font-semibold">
                    <div
                        class="tw-my-3 tw-text-[1.1rem] md:tw-text-[1.2rem] tw-font-bold tw-text-[#0F3172] content-details"
                        [innerHTML]="campaignData?.campaigndetails?.title1"
                        id="checking"
                    ></div>
                </div>
                <div class="tw-flex-1">
                    <div
                        class="tw-flex-1 tw-px-4 md:tw-px-0 tw-text-[16px] content-details tw-whitespace-pre-line tw-mt-0 tw-text-center md:tw-text-left"
                        [innerHTML]="campaignData?.campaigndetails?.title1Desc"
                    ></div>
                </div>
            </div>
        </div>
        <div
            *ngIf="
                campaignData?.campaigndetails?.title2 ||
                campaignData?.campaigndetails?.title2Desc
            "
            class="tw-flex tw-flex-col tw-px-[30px] xl:tw-px-0 tw-py-5 tw-bg-[#F9FAFF]"
        >
            <div class="container">
                <div class="tw-flex-1 tw-text-2xl tw-font-semibold">
                    <div
                        class="tw-my-3 tw-text-[1.1rem] md:tw-text-[1.2rem] tw-font-bold tw-text-[#0F3172] content-details"
                        [innerHTML]="campaignData?.campaigndetails?.title2"
                    ></div>
                </div>
                <div class="tw-flex-1">
                    <div
                        class="tw-flex-1 tw-px-4 md:tw-px-0 tw-text-[16px] content-details tw-whitespace-pre-line tw-mt-0 tw-text-left"
                        [innerHTML]="campaignData?.campaigndetails?.title2Desc"
                    ></div>
                </div>
            </div>
        </div>
        <div
            *ngIf="
                campaignData?.campaigndetails?.title3 ||
                campaignData?.campaigndetails?.title3Desc
            "
            class="tw-flex tw-flex-col tw-gap-y-5 tw-px-[30px] xl:tw-px-0 tw-py-5"
        >
            <div class="container">
                <div class="tw-flex-1 tw-text-2xl tw-font-semibold">
                    <div
                        class="tw-my-3 tw-text-[1.1rem] md:tw-text-[1.2rem] tw-font-bold tw-text-[#0F3172] content-details"
                        [innerHTML]="campaignData?.campaigndetails?.title3"
                    ></div>
                </div>
                <div class="tw-flex-1">
                    <div
                        class="tw-flex-1 tw-px-4 md:tw-px-0 tw-text-[16px] content-details tw-whitespace-pre-line tw-mt-0 tw-text-left"
                        [innerHTML]="campaignData?.campaigndetails?.title3Desc"
                    ></div>
                </div>
            </div>
        </div>
    </section>
    <section class="tw-flex tw-mt-16 tw-px-[30px] xl:tw-px-0">
        <div class="tw-flex tw-flex-col tw-items-center tw-gap-5 tw-mx-auto">
            <button
                [attr.ga-event-id]="
                    campaignData?.campaigndetails?.campaignName +
                    '_apply_now_campaign_click'
                "
                ga-event-category="Campaign Page Button"
                ga-event-label="Apply Now Bottom Button Click"
                ga-track="track"
                class="tw-btn-warning tw-w-full md:tw-w-auto"
                (click)="
                    openProductPage(
                        campaignData?.campaigndetails?.campaignDetUrl,
                        campaignData?.campaignpartner,
                        campaignData?.campaignsource,
                        campaignData?.ctaType
                    )
                "
            >
                {{ campaignData?.campaigndetails?.ctaName }}
            </button>
            <a
                *ngIf="campaignData?.campaigndetails?.uploadTncUrl"
                ga-event-id="terms_and_condition_button_camp_click"
                ga-event-category="Campaign Page Button"
                ga-event-label="Terms and Condition Button"
                ga-track="track"
                [href]="campaignData?.campaigndetails?.uploadTncUrl"
                class="tw-cursor-pointer tw-text-blue-600 tw-underline"
                target="_blank"
            >
                {{ "CAMPAIGN_PAGE.TC_PLACEHOLDER" | translate }}
            </a>
        </div>
    </section>
</main>

<app-footer [selectedLanguage]="selectedLanguage" />
